import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ILog, Log } from '../../_models/Log';
import { createAction, createReducer, props, on, createFeatureSelector, createSelector, Action } from '@ngrx/store';

export const name = 'logs';

export interface LogsState extends EntityState<ILog> {
  selectedId: number;
  isInitialized: boolean;
  loading: boolean;
}

function selectLog(a: ILog): any {
  return a.id;
}

function sortById(a: ILog, b: ILog): number {
  if (a.id < b.id) {
    return -1;
  } else if (a.id > b.id) {
    return 1;
  } else {
    return 0;
  }
}

const adapter: EntityAdapter<ILog> = createEntityAdapter<ILog>({
  selectId: selectLog,
  sortComparer: sortById,
});

const initialState: LogsState = adapter.getInitialState({
  selectedId: -1,
  isInitialized: false,
  loading: true,
});

export const loadLogsAction = createAction('[Logs] Load Logs', props<{ force: boolean }>());
export const loadLogsErrorAction = createAction('[Logs] Load Logs Error');
export const loadLogsSuccessAction = createAction('[Logs] Load Logs Success', props<{ payload: ILog[] }>());
export const setLogsAction = createAction('[Logs] Add Log', props<{ payload: ILog[] }>());

const reducer = createReducer(
  initialState,
  on(loadLogsSuccessAction, (state, { payload }) => {
    return adapter.setAll(payload, {
      ...state,
      isInitialized: true,
      loading: false,
    });
  }),
  on(loadLogsErrorAction, (state) => {
    return { ...state, loading: false };
  }),
  on(setLogsAction, (state, { payload }) => {
    return adapter.setAll(payload, state);
  })
);

export function logsReducer(state: LogsState | undefined, action: Action): LogsState {
  return reducer(state, action);
}

/* SELECTOR */
const selectLogsState = createFeatureSelector<LogsState>(name);

const isInitialized = (state: LogsState) => state.isInitialized;
export const selectIsLogsInitialized = createSelector(selectLogsState, isInitialized);

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectAllLogs = createSelector(selectLogsState, (state) => {
  return state.loading
    ? undefined
    : state.ids
        .map((id: any) => new Log(state.entities[id]))
        .sort((a, b) => {
          if (a.dateHeure < b.dateHeure) {
            return 1;
          } else if (a.dateHeure > b.dateHeure) {
            return -1;
          } else {
            return 0;
          }
        });
});
